import { DataGrid } from '@cimplico/components';
import { CheckIcon } from '@heroicons/react/20/solid';
import { EntityAccount } from '../../../../types/entity';

type AccountProps = {
    account: EntityAccount;
};
function Account({ account }: AccountProps): JSX.Element {
    return (
        <DataGrid.Row id={account.id}>
            <p className="text-xs text-gray-600">{account.code}</p>
            <div>
                <p className="text-xs text-gray-600 py-1 text-left">{account.name}</p>
                {account.description && <p className="text-xs text-gray-500 mt-1 text-left">{account.description}</p>}
            </div>
            <p className="text-xs text-gray-600">{account.type}</p>
            <p className="text-xs text-gray-600">{account.reportCode}</p>
            {account.canJournal ? <CheckIcon className="text-indigo-600 h-4 w-4" /> : <span></span>}
            {account.isTaxAccount ? <CheckIcon className="text-indigo-600 h-4 w-4" /> : <span></span>}
        </DataGrid.Row>
    );
}

export default Account;
